import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-m-2 w-56" }

import { ref } from 'vue';

import Button from 'primevue/button';
import Popover from 'primevue/popover';

import UserAvatar from '../components/UserAvatar.vue';
import LogoutButton from '../components/LogoutButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserMenu',
  setup(__props) {

const op = ref();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Button), {
      class: "!bg-transparent hover:!bg-slate-800",
      severity: "secondary",
      text: "",
      onClick: _cache[0] || (_cache[0] = (event) => op.value.toggle(event))
    }, {
      default: _withCtx(() => [
        _createVNode(UserAvatar),
        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "pi pi-chevron-down text-white" }, null, -1))
      ]),
      _: 1
    }),
    _createVNode(_unref(Popover), {
      ref_key: "op",
      ref: op,
      pt: {
      root: {
        class: 'after:hidden before:hidden ',
      },
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(LogoutButton)
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})